interface FormDocument {
  id?: unknown;
  sharepointFileId?: unknown;
  [key: string]: unknown;
}

export default function resolveDocumentId(document?: FormDocument) {
  const { id, sharepointFileId } = document ?? {};

  if (typeof id === 'string') {
    return id;
  }

  return typeof sharepointFileId === 'string' ? sharepointFileId : '';
}
